<div class="card">
  <div class="flex items-start justify-between gap-2 px-4 pt-4 pb-2">
    <div>
      <h2 class="text-base font-medium m-0">Appels API</h2>
      <p class="text-secondary text-xs m-0">Requêtes envoyées par l'onglet, de la plus récente à la plus ancienne.</p>
    </div>
    <button mat-icon-button type="button" (click)="clear()" [disabled]="!entries.length" matTooltip="Vider le journal">
      <mat-icon>delete_sweep</mat-icon>
    </button>
  </div>

  <div *ngIf="!entries.length" class="empty-state">Aucun appel pour l'instant.</div>

  <div class="journal">
    <div *ngFor="let entry of entries; trackBy: trackById" class="entry">
      <button type="button" class="entry-header" (click)="toggle(entry)">
        <mat-icon class="chevron">{{ entry.id === expandedId ? 'expand_more' : 'chevron_right' }}</mat-icon>
        <span class="method" [ngClass]="methodClasses[entry.method]">{{ entry.method }}</span>
        <code class="entry-url" [matTooltip]="entry.url">{{ entry.url }}</code>
        <span class="px-2 py-1 rounded text-xs font-medium" [ngClass]="httpStatusClass(entry.status)">
          {{ entry.status || 'Échec' }}
        </span>
      </button>

      <div *ngIf="entry.id === expandedId" class="px-3 pb-3">
        <div class="text-secondary text-xs mb-2">
          {{ entry.sentAt | date: 'HH:mm:ss' }} · {{ entry.durationMs }} ms · {{ entry.statusText }}
        </div>

        <ng-container *ngIf="entry.requestText">
          <div class="section-title mb-1">Corps envoyé</div>
          <pre class="code-block mb-3">{{ entry.requestText }}</pre>
        </ng-container>

        <div *ngFor="let header of entry.headers" class="text-xs">
          <span class="text-secondary">{{ header.name }} :</span>
          <code>{{ header.value }}</code>
        </div>

        <div class="flex items-center justify-between mt-2">
          <span class="section-title">Réponse</span>
          <button
            mat-icon-button
            type="button"
            (click)="copy(entry)"
            [disabled]="!entry.responseText"
            [matTooltip]="copiedId === entry.id ? 'Copié !' : 'Copier la réponse'"
          >
            <mat-icon>{{ copiedId === entry.id ? 'check' : 'content_copy' }}</mat-icon>
          </button>
        </div>
        <pre class="code-block response">{{ entry.responseText || '(réponse vide)' }}</pre>
      </div>
    </div>
  </div>
</div>
